import type { CommunityDetail } from 'models';
import { ContentWrapper } from 'ui';

import { About, Administrators, Description } from '../components';

type P = {
  community: CommunityDetail;
};

const CommunityAboutContent = ({ community }: P) => (
  <ContentWrapper
    aside={
      <>
        <About community={community} />
        <Administrators community={community} />
      </>
    }
  >
    <Description community={community} />
  </ContentWrapper>
);

export default CommunityAboutContent;
